import script from "./DomainRecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainRecordList.vue?vue&type=script&setup=true&lang=js"

import "./DomainRecordList.vue?vue&type=style&index=0&id=d72c0416&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d72c0416"]])

export default __exports__